<template>
  <main>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("heading.certificates") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="dialog = !dialog">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <div class="d-flex justify-lg-space-between">
      <!-- table -->
      <v-text-field :label="$t('table.email')" v-model="query.email"> </v-text-field>
      <v-text-field
        class="mx-4"
        :label="$t('table.serial_number')"
        v-model="query.serial_number"
      >
      </v-text-field>
      <TextField
        :items="['excellence', 'achievement', 'completion']"
        v-model="query.type"
        inputType="select"
        
        :model="query"
        fieldName="type"
      />
    </div>
    <v-btn color="primary" @click="rendering"> {{ $t("button.search") }} </v-btn>
    <v-btn class="mx-4" @click="reset"> {{ $t("button.reset") }} </v-btn>
    <wrapping-table
      v-if="render"
      :headersName="$options.headersName"
      :pathName="`certificates?email=${query.email}&serial_number=${query.serial_number}&type=${query.type}`"
      ref="table_ref"
    >
      <template slot-scope="{ item, index }">
        <td>
          <a
            :href="`https://www.solutionplus.net/certificates/${item.serial_number}`"
            target="_blank"
          >
            {{ item.serial_number }}
          </a>
        </td>
        <td>{{ item.type }}</td>
        <td>{{ item.training_department && item.training_department.name }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.email }}</td>

        <td>
          {{ returnDate(item.start_date.date) }}
        </td>
        <td>
          {{ returnDate(item.end_date.date) }}
        </td>

        <td>
          <v-icon small title="edit" @click="handleEdit(item, index)"> mdi-pencil</v-icon>
          <v-icon small title="delete" @click="handleDelete(item, index)">
            mdi-delete</v-icon
          >
          <a
            :href="`https://www.solutionplus.net/certificates/${item.serial_number}`"
            target="_blank"
          >
            <v-icon small title="show"> mdi-eye</v-icon>
          </a>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
    <!-- dialog -->
    <DialogComponent v-model="dialog">
      <template #heading>
        <v-card-title>{{ dialogTitle }}</v-card-title>
      </template>
      <template #body>
        <!-- <v-col cols="12" v-if="isEdited">
          <locale-select @change="fireLocaleChange" />
        </v-col> -->
        <v-container>
          <form-wrapper :validator="$v.form">
            <v-form @submit.prevent="handleSubmit">
              <v-col cols="12">
                <TextField :model="form" fieldName="name" />
                <TextField :model="form" fieldName="email" />

                <TextField
                  :items="['excellence', 'achievement', 'completion']"
                  v-model="form.type"
                  inputType="select"
                  :model="form"
                  fieldName="type"
                />
                <TextField
                  :items="certificateTrainingData"
                  v-model="form.training_department"
                  inputType="select"
                  :model="form"
                  fieldName="training_department"
                />
                <v-menu
                  ref="start_date_menu"
                  v-model="start_date_menu"
                  :close-on-content-click="false"
                  :return-value.sync="start_date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.start_date"
                      :label="$t('input.start_date')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.start_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="start_date_menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.start_date_menu.save(start_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-menu
                  ref="end_date_menu"
                  v-model="end_date_menu"
                  :close-on-content-click="false"
                  :return-value.sync="end_date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.end_date"
                      :label="$t('input.end_date')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.end_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="end_date_menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.end_date_menu.save(end_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-menu
                  ref="release_date_menu"
                  v-model="release_date_menu"
                  :close-on-content-click="false"
                  :return-value.sync="release_date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.release_date"
                      :label="$t('input.release_date')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.release_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="release_date_menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.release_date_menu.save(release_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-btn
                  type="submit"
                  class="primary"
                  :disabled="$v.form.$invalid"
                  :loading="btnLoading"
                  >{{ $t("button.save") }}</v-btn
                >
                <v-btn class="warning mx-2" @click="dialog = !dialog">{{
                  $t("button.close")
                }}</v-btn>
              </v-col>
            </v-form>
          </form-wrapper>
        </v-container>
      </template>
    </DialogComponent>
    <!-- dialog -->
  </main>
</template>

<script>
import { required, minLength, maxLength, email } from "vuelidate/lib/validators";
import {
  StoreData,
  ShowData,
  UpdateData,
  DeleteData,
  IndexData,
} from "@/helpers/apiMethods";
import DateTimePicker from "@/components/DateTimePicker";
import cookie from "js-cookie";

export default {
  components: {
    DateTimePicker,
  },
  headersName: [
    "serial_number",
    "type",
    'training_department',
    "name",
    "email",
    "start_date",
    "end_date",
    "configs",
  ],
  name: "Certificates",
  data() {
    return {
      certificateTrainingData: [],
      query: {
        email: "",
        serial_number: "",
        type: "",
      },
      isEdited: false,
      btnLoading: false,
      dialog: false,
      render: true,
      form: {
        name: "",
        training_department:"",
        email: "",
        type: "achievement",
        start_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000),
        end_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000),
        release_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000),
      },
      start_date_menu: false,
      end_date_menu: false,
      release_date_menu: false,
      certificateId: "",
      certificateIndex: "",
      locale: cookie.get("language"),
      start_date: "",
      end_date: "",
      release_date: "",
    };
  },

  methods: {
    reset() {
      this.query = {
        email: "",
        serial_number: "",
        type: "",
      };
      this.rendering();
    },
    rendering() {
      this.render = false;
      this.$nextTick(() => {
        this.render = true;
      });
    },
    returnDate(date) {
      if (date) {
        let splitDate = date.split(" ");
        return splitDate[0];
      }
      return date;
    },
    fireLocaleChange(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },
    trainingDepartments() {
      IndexData({ reqName: "training-departments" })
        .then((res) => {
          const { data } = res.data;
          this.certificateTrainingData = data;
        })
        .catch((err) => console.log(err));
    },
    handleCreateState() {
      StoreData({ reqName: "certificates", data: this.form })
        .then((res) => {
          const { certificate } = res.data;
          this.$refs.table_ref.items.push(certificate);
          this.resetDialog();
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleUpdateState() {
    if(this.form.training_department.id){
      this.form.training_department=this.form.training_department.id
    }
      UpdateData({
        reqName: "certificates",
        data: { ...this.form, _method: "put", locale: this.locale },
        id: this.certificateId,
      })
        .then((res) => {
          const { certificate } = res.data;
          const { items } = this.$refs.table_ref;
          this.$set(items, this.certificateIndex, certificate);

          this.resetDialog();

          console.log(certificate);
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleShowData(locale) {
      ShowData({ reqName: "certificates", id: this.certificateId, locale })
        .then((res) => {
          const { certificate } = res.data;
          this.form = certificate;
          this.form.start_date = this.returnDate(certificate.start_date.date);
          this.form.end_date = this.returnDate(certificate.end_date.date);
          this.form.release_date = this.returnDate(certificate.release_date.date);
        })
        .catch((err) => console.log(err));
    },
    resetDialog() {
      this.$v.form.$reset();
      this.form = {};
      this.btnLoading = false;
      this.dialog = false;
      this.isEdited = false;
      this.$store.dispatch("ClearServerErrors");
    },
    handleSubmit() {
      this.btnLoading = true;
      if (!this.isEdited) {
        // in case create
        this.handleCreateState();
      } else {
        // in case upadate
        this.handleUpdateState();
      }
    },
    handleDelete({ serial_number }, index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          DeleteData({ reqName: "certificates", id: serial_number })
            .then(() => {
              // this.$delete(this.items, index);
              this.rendering();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    handleEdit({ serial_number }, index) {
      this.certificateId = serial_number;
      this.certificateIndex = index;
      this.dialog = true;
      this.isEdited = true;
      this.handleShowData(this.locale);
    },
  },
  mounted(){
    this.trainingDepartments()
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      email: {
        required,
        email,
      },
      training_department:{
        required
      },
      type: {
        required,
      },
      release_date: {
        required,
      },
      start_date: {
        required,
      },
      end_date: {
        required,
      },
    },
  },
  computed: {
    dialogTitle() {
      if (!this.isEdited) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.resetDialog();
        }
      },
      immediate: true,
    },
  },
};
</script>
